import CloseEditModal from './CloseEditModal.component';

export default CloseEditModal;
